module.exports = __webpack_public_path__ + "img/curled-up-doggo.f4b5e1cd.png";